﻿<!-- prettier-ignore -->
<script lang="ts">

// import { defineAsyncComponent } from 'vue';

// const Alert = defineAsyncComponent(() => import('./components/Feature/Alert/AlertMain.vue'));
// const AlertBanner = defineAsyncComponent(  () => import('./components/Feature/AlertBanner/AlertBanner.vue'));
// const AnchorMenu = defineAsyncComponent(() => import('./components/Feature/AnchorMenu/AnchorMenu.vue'));
// const BetalingServiceTilmelding = defineAsyncComponent(() => import('./components/Feature/BetalingsServiceTilmelding/BetalingsServiceTilmelding.vue'));
// const BikeTheftClaimFlow = defineAsyncComponent(() => import('./components/Feature/BikeTheftClaimFlow/views/BikeTheftClaimFlow.vue'));
// const BoxList = defineAsyncComponent(() => import('./components/Feature/BoxList/BoxListMain.vue'));
// const Breadcrumb = defineAsyncComponent(() => import('./components/Feature/Breadcrumb/Breadcrumb.vue'));
// const Checkout = defineAsyncComponent(() => import('./components/Feature/Checkout/CheckoutMain.vue'));
// const ClaimListUploadFile = defineAsyncComponent(() => import('./components/Feature/ClaimList/ClaimListUploadFile.vue'));
// const ClaimOverview = defineAsyncComponent(() => import('./components/Feature/ClaimOverview/Main.vue'));
// const CprConsent = defineAsyncComponent(() => import('./components/Feature/CprConsent/CprConsent.vue'));
// const CreateMember = defineAsyncComponent(() => import('./components/Feature/CreateMember/CreateMemberMain.vue'));
// const CreatePowerOfAttorney = defineAsyncComponent(() => import('./components/Feature/PowerOfAttorney/CreatePowerOfAttorney.vue'));
// const CviHeader = defineAsyncComponent(() => import('./components/Feature/CviHeader/CviHeader.vue'));
// const DebuggingTool = defineAsyncComponent(() => import('./components/UI/DebuggingTool.vue'));
// const DocumentPage = defineAsyncComponent(() => import('./components/Feature/DocumentPage/DocumentPage.vue'));
// const DocumentSection = defineAsyncComponent(() => import('./components/Feature/DocumentSection/DocumentSection.vue'));
// const EditPowerOfAttorney = defineAsyncComponent(() => import('./components/Feature/PowerOfAttorney/EditPowerOfAttorney.vue'));
// const GenericContent = defineAsyncComponent(() => import('./components/Feature/GenericContent/GenericContent.vue'));
// const InternetExplorerNotification = defineAsyncComponent(() => import('./components/UI/InternetExplorerNotification.vue'));
// const LoginOutOfServiceNotification = defineAsyncComponent(() => import('./components/UI/LoginOutOfServiceNotification.vue'));
// const LoyaltyReward = defineAsyncComponent(() => import('./components/Feature/LoyaltyReward/LoyaltyReward.vue'));
// const MemberInformation = defineAsyncComponent(() => import('./components/Feature/MemberInformation/MemberInformation.vue'));
// const MyClaims = defineAsyncComponent(() => import('./components/Feature/MyClaims/MyClaims.vue'));
// const NavigationList = defineAsyncComponent(() => import('./components/Feature/Navigation/NavigationList.vue'));
// const NbaMain = defineAsyncComponent(() => import('./components/Feature/NBA/NbaMain.vue'));
// const PartnershipReferral = defineAsyncComponent(() => import('./components/Feature/PartnershipReferral/views/PartnershipReferral.vue'));
// const PaymentFrequency = defineAsyncComponent(() => import('./components/Feature/NewPolicy/PaymentFrequency/PaymentFrequency.vue'));
// const Permissions = defineAsyncComponent(() => import( '@/components/Feature/Permissions/Main.vue'));
// const Policy = defineAsyncComponent(() => import('./components/Feature/NewPolicy/Policy.vue'));
// const PolicySection = defineAsyncComponent(() => import('./components/Feature/PolicySection/PolicySection.vue'));
// const PowerOfAttorney = defineAsyncComponent(() => import('./components/Feature/PowerOfAttorney/PowerOfAttorney.vue'));
// const ProposalBasket = defineAsyncComponent(() => import('./components/Feature/ProposalBasket/ProposalBasket.vue'));
// const ProposalsAwaitingApproval = defineAsyncComponent(() => import('./components/Feature/ProposalsAwaitingApproval/ProposalsAwaitingApproval.vue'));
// const QuestionTree = defineAsyncComponent(() => import('./components/Feature/ClaimQuestionTree/QuestionTreeMain.vue'));
// const QuickQuoteBasket = defineAsyncComponent(() => import('./components/Feature/QuickQuoteBasket/QuickQuoteBasketMain.vue'));
// const QuickQuoteConversion = defineAsyncComponent(() => import('./components/Feature/QuickQuote/QuickQuoteConversion.vue'));
// const QuickQuoteFlow = defineAsyncComponent(() => import('./components/Feature/QuickQuote/QuickQuoteMain.vue'));
// const ReportClaim = defineAsyncComponent(() => import('./components/Feature/Claims/flows/ReportClaimMain.vue'));
// const SalesforceChatTracking = defineAsyncComponent(() => import('./components/Feature/SalesforceChat/SalesforceChatTracking.vue'));
// const SharedFooter = defineAsyncComponent(() => import('./components/Feature/Footer/Footer.vue'));
// const SiteHeader = defineAsyncComponent(() => import('./components/Feature/Header/SiteHeader.vue'));
// const StudyFlow = defineAsyncComponent(() => import('./components/Feature/Study/StudyMain.vue'));
// const TagManager = defineAsyncComponent(() => import('./components/UI/TagManager.vue'));
// const Timeout = defineAsyncComponent(() => import('./components/Feature/Timeout/Timeout.vue'));
// const TopBannerPowerOfAttorney = defineAsyncComponent(() => import('./components/Feature/PowerOfAttorney/TopBannerPowerOfAttorney.vue'));
// const TravelLetter = defineAsyncComponent(() => import('./components/Feature/TravelLetter/TravelLetterMain.vue'));
// const TrustFooter = defineAsyncComponent(() => import('./components/UI/TrustFooter.vue'));

import Alert from './components/Feature/Alert/AlertMain.vue';
import AlertBanner from './components/Feature/AlertBanner/AlertBanner.vue';
import AnchorMenu from './components/Feature/AnchorMenu/AnchorMenu.vue';
import BetalingServiceTilmelding from './components/Feature/BetalingsServiceTilmelding/BetalingsServiceTilmelding.vue';
import BikeTheftClaimFlow from './components/Feature/BikeTheftClaimFlow/views/BikeTheftClaimFlow.vue';
import BoxList from './components/Feature/BoxList/BoxListMain.vue';
import Breadcrumb from './components/Feature/Breadcrumb/Breadcrumb.vue';
import Checkout from './components/Feature/Checkout/CheckoutMain.vue';
import CprConsent from './components/Feature/CprConsent/CprConsent.vue';
import CreateMember from './components/Feature/CreateMember/CreateMemberMain.vue';
import CreatePowerOfAttorney from './components/Feature/PowerOfAttorney/CreatePowerOfAttorney.vue';
import CviHeader from './components/Feature/CviHeader/CviHeader.vue';
import DebuggingTool from './components/UI/DebuggingTool.vue';
import DocumentPage from './components/Feature/DocumentPage/DocumentPage.vue';
import DocumentSection from './components/Feature/DocumentSection/DocumentSection.vue';
import EditPowerOfAttorney from './components/Feature/PowerOfAttorney/EditPowerOfAttorney.vue';
import ErrorPage from './components/UI/ErrorPage.vue';
import GenericContent from './components/Feature/GenericContent/GenericContent.vue';
import InternetExplorerNotification from './components/UI/InternetExplorerNotification.vue';
import LabelAndTooltip from './components/UI/LabelAndTooltip.vue';
import LoginOutOfServiceNotification from './components/UI/LoginOutOfServiceNotification.vue';
import LoyaltyReward from './components/Feature/LoyaltyReward/LoyaltyReward.vue';
import MemberInformation from './components/Feature/MemberInformation/MemberInformation.vue';
import NavigationList from './components/Feature/Navigation/NavigationList.vue';
import NbaMain from './components/Feature/NBA/NbaMain.vue';
import PartnershipReferral from './components/Feature/PartnershipReferral/views/PartnershipReferral.vue';
import PaymentFrequency from './components/Feature/NewPolicy/PaymentFrequency/PaymentFrequency.vue';
import Permissions from  './components/Feature/Permissions/Main.vue';
import Policy from './components/Feature/NewPolicy/Policy.vue';
import PolicySection from './components/Feature/PolicySection/PolicySection.vue';
import PowerOfAttorney from './components/Feature/PowerOfAttorney/PowerOfAttorney.vue';
import ProposalBasket from './components/Feature/ProposalBasket/ProposalBasket.vue';
import ProposalsAwaitingApproval from './components/Feature/ProposalsAwaitingApproval/ProposalsAwaitingApproval.vue';
import QuestionTree from './components/Feature/ClaimQuestionTree/QuestionTreeMain.vue';
import QuickQuoteBasket from './components/Feature/QuickQuoteBasket/QuickQuoteBasketMain.vue';
import QuickQuoteConversion from './components/Feature/QuickQuote/QuickQuoteConversion.vue';
import QuickQuoteFlow from './components/Feature/QuickQuote/QuickQuoteMain.vue';
import ReportClaim from './components/Feature/Claims/flows/ReportClaimMain.vue';
import SalesforceChatTracking from './components/Feature/SalesforceChat/SalesforceChatTracking.vue';
import SharedFooter from './components/Feature/Footer/Footer.vue';
import SiteHeader from './components/Feature/Header/SiteHeader.vue';
import StudyFlow from './components/Feature/Study/StudyMain.vue';
import TagManager from './components/UI/TagManager.vue';
import Timeout from './components/Feature/Timeout/Timeout.vue';
import TopBannerPowerOfAttorney from './components/Feature/PowerOfAttorney/TopBannerPowerOfAttorney.vue';
import TravelLetter from './components/Feature/TravelLetter/TravelLetterMain.vue';
import TrustFooter from './components/UI/TrustFooter.vue';

export default {
  name: 'MinSide',
  components: {
    Alert,
    AlertBanner,
    AnchorMenu,
    BetalingServiceTilmelding,
    BikeTheftClaimFlow,
    BoxList,
    Checkout,
    Breadcrumb,
    CprConsent,
    CreateMember,
    CreatePowerOfAttorney,
    CviHeader,
    DebuggingTool,
    DocumentPage,
    DocumentSection,
    EditPowerOfAttorney,
    ErrorPage,
    GenericContent,
    InternetExplorerNotification,
    LabelAndTooltip,
    LoginOutOfServiceNotification,
    LoyaltyReward,
    MemberInformation,
    NavigationList,
    NbaMain,
    PartnershipReferral,
    PaymentFrequency,
    Permissions,
    Policy,
    PolicySection,
    ProposalBasket,
    ProposalsAwaitingApproval,
    PowerOfAttorney,
    QuestionTree,
    QuickQuoteConversion,
    QuickQuoteBasket,
    QuickQuoteFlow,
    ReportClaim,
    SalesforceChatTracking,
    SharedFooter,
    StudyFlow,
    SiteHeader,
    TagManager,
    Timeout,
    TopBannerPowerOfAttorney,
    TravelLetter,
    TrustFooter,
  },
  methods: {
    setScroll(a: any, b: any, c: any) {
      console.log("I'm never scrolling????", a, b, c);
    }
  }
};
</script>
